module.exports = __webpack_public_path__ + "static/media/root_beer_stamp.952396e9.svg";